import { useEffect, useState } from "react";

function SearchForm() {
  const [widgetReady, setWidgetReady] = useState(false);
  const isReactSnap =
    typeof navigator !== "undefined" &&
    navigator.userAgent.includes("ReactSnap");

  useEffect(() => {
    if (typeof window === "undefined" || isReactSnap) return;

    // 1. Set up the widget config BEFORE script loads
    window.OVExplore8 = {
      preferences: {
        languageId: "1",
        siteItemId: "177652",
        sid1: "",
        sid2: "",
        referrer: "",
        resultWindowType: "_self",
        showStateNCountryWithPorts: true,
        cruiseSearchFields: {
          basic: ["destination", "departureport", "sailingdate"],
          advance: ["duration", "cruiseline", "ship"],
        },
      },
      siteSettings: {
        productType: "cruise",
        domain: "res.cruisemaster-me.com",
        numberOfCols: 3,
        themeColor: "#fff|#01639d|#01639d|#fff",
      },
      cruiseWidgetSettings: {
        widgetType: "single",
      },
    };

    // 2. Load the script only once
    const scriptId = "ovexplore-script";
    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://content.cdn705.com/Content/WebApps/OdyVExplore/OVExplore.min.js";
      script.async = true;
      script.onload = () => {
        console.log("OVExplore script loaded");
        setTimeout(() => setWidgetReady(true), 100); // let it settle briefly
      };
      script.onerror = (e) =>
        console.error("Failed to load OVExplore script", e);
      document.body.appendChild(script);
    } else {
      // Script already exists? assume it's ready
      setWidgetReady(true);
    }
  }, [isReactSnap]);

  return (
    <div className="home ody-form-container-custom">
      {!isReactSnap && widgetReady && (
        <div id="option-eight">
          <ody-search-form search-form-settings="OVExplore8"></ody-search-form>
        </div>
      )}
    </div>
  );
}

export default SearchForm;